import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import CommercialCampaignsListItem from './CommercialCampaignsListItem';
import CommercialCampaignsDetails from './details/CommercialCampaignsDetails';
import CommercialCampaignsDetailsRightSidebar from './details/CommercialCampaignsDetailsRightSidebar';

import buttons from './CommercialCampaignsButtons';
import events from './CommercialCampaignsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('commercialcampaigns'),
	routes: [
		{
			path: 'commercialcampaigns/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'commercialcampaigns'),
			element: (
				<DetailsPage
					key="commercialcampaigns/add"
					module="commercialcampaigns"
					tabs={CommercialCampaignsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'commercialcampaigns/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'commercialcampaigns'),
			element: (
				<DetailsPage
					key="commercialcampaigns/details"
					module="commercialcampaigns"
					tabs={CommercialCampaignsDetails}
					buttons={buttons.details}
					events={events}
					getRightSidebarSections={CommercialCampaignsDetailsRightSidebar}
				/>
			)
		},
		{
			path: 'commercialcampaigns/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'commercialcampaigns'),
			element: (
				<ViewPage
					key="commercialcampaigns/view"
					module="commercialcampaigns"
					content={{ type: 'list', itemLayout: CommercialCampaignsListItem, id: 'commercialCampaignsView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
